<div>
  <mat-form-field>
    <mat-label>Mês e Ano</mat-label>
    <input matInput [matDatepicker]="dp" [formControl]="date" [min]="min || null" [max]="max || null">
    <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp
                    [startView]="formatSelection"
                    (monthSelected)="setMonthAndYear($event, dp)"
                    panelClass="month-picker">
    </mat-datepicker>
  </mat-form-field>
</div>